export enum ApplicationAuthenticationProviderType {
    OIDC = 'OIDC',
    EMBEDDED = 'EMBEDDED',
    NOT_CONFIGURED = 'NOT_CONFIGURED',
}
